import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ModalController, Loading, ToastController, LoadingController, AlertController } from 'ionic-angular';
import { AddExpensePage } from '../../../../pages/retirement-tools/retirement-calculator/add-expense/add-expense';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';

@Component({
  selector: 'gastos',
  templateUrl: 'gastos.html'
})
export class GastosComponent {
  @Input() backButton: boolean = false;
  @Input() data: any;
  @Output() dataReturn: EventEmitter<any> = new EventEmitter<any>();
  @Output() formBack: EventEmitter<void> = new EventEmitter<void>();
  @Output() realTime: EventEmitter<any> = new EventEmitter<any>();

  todo = [
    { label: '', type: '', value: { today: 0, retirement: 0 }, otherExpense: false }
  ];

  today = {
    labels: ['', '', ''],
    values: [0, 0, 0],
    total: 0
  }

  retirement = {
    labels: ['', '', ''],
    values: [0, 0, 0],
    total: 0
  }
  doughnutChartDataopts = {
    rotation: 1 * Math.PI,
    circumference: 1 * Math.PI, responsive: true, label: ['Necesario', 'Estilo de vida', 'Adicional'],
    labels: ['Necesario', 'Estilo de vida', 'Adicional']
    , legend: { display: false }
  }
  public doughnutChartLabels1: string[] = ['Necesario', 'Estilo de vida', 'Adicional'];
  public _doughnutChartLabels1: string[] = [];
  public doughnutChartData1: number[] = [0, 0, 0];
  public _doughnutChartData1: number[] = [];
  public doughnutChartLabels2: string[] = ['Necesario', 'Estilo de vida', 'Adicional'];
  public _doughnutChartLabels2: string[] = [];
  public doughnutChartData2: number[] = [0, 0, 0];
  public _doughnutChartData2: number[] = [];
  public doughnutChartType: string = 'doughnut';
  public colors = ['primary2', 'royal', 'secondary'];
  public chartOptions = {
    legend: { display: false, reverse: true }
  };

  public dougnutChartcolors: Array<any> = [
    {
      backgroundColor: ['#007AA9', '#463685', '#59D7B5'],
      label: ['Necesario', 'Estilo de vida', 'Adicional']
    }
  ];
  public otherExpense: boolean = false;
  loading: Loading;

  constructor(public toastCtrl: ToastController, private loadingCtrl: LoadingController, private modalCtrl: ModalController, public alertCtrl: AlertController, private afs: AngularFirestore, private afAuth: AngularFireAuth) { }

  updateItem(item: any, index: number) {
    const modal = this.modalCtrl.create(AddExpensePage, item);
    modal.present();
    modal.onDidDismiss(data => {
      if (data) {
        if (data.type == 'update') {
          this.todo[index] = data.data;
          this.change();
        }
      }
    });
  }

  presentModal() {
    const modal = this.modalCtrl.create(AddExpensePage);
    modal.present();
    modal.onDidDismiss(data => {
      if (data) {
        if (data.type == 'save') {
          this.todo.push(data.data);
          this.change();
        }
      }
    });
  }

  ngOnInit() {
    if (this.data) {
      this.todo = this.data;
    }
    this.calculate();
    this.paint1();
    this.paint2();
  }

  calculate() {
    let types: string[] = [];
    this.todo.forEach((element) => {
      types.push(element.type);
    });
    types = types.filter((element, index) => {
      return types.indexOf(element) == index;
    });
    let todayValues: number[] = [];
    let todayTotal = 0;
    types.forEach(element => {
      let suma = 0;
      this.todo.forEach(element2 => {
        if (element2.type == element) {
          suma += Number(element2.value.today);
        }
      });
      todayTotal += suma;
      todayValues.push(suma);
    });
    this.today.labels = types;
    this.today.values = todayValues;
    this.today.total = todayTotal;
    let retirementValues: number[] = [];
    let retirementTotal = 0;
    types.forEach(element => {
      let suma = 0;
      this.todo.forEach(element2 => {
        if (element2.type == element) {
          suma += Number(element2.value.retirement);
        }
      });
      retirementTotal += suma;
      retirementValues.push(suma);
    });
    this.retirement.labels = types;
    this.retirement.values = retirementValues;
    this.retirement.total = retirementTotal;
  }

  paint1() {
    this._doughnutChartLabels1 = ['Necesario', 'Estilo de vida', 'Adicional'];
    this._doughnutChartLabels1.forEach((ele, index) => {
      if (this.today.labels.indexOf(ele) > -1) {
        this._doughnutChartData1[index] = this.today.values[this.today.labels.indexOf(ele)];
      }
      else {
        this._doughnutChartData1[index] = 0;
      }
    });
    this._doughnutChartData1 = this._doughnutChartData1.map(element => {
      return Math.round(element);
    });
    this.doughnutChartData1 = this._doughnutChartData1;
  }

  paint2() {
    this._doughnutChartLabels2 = ['Necesario', 'Estilo de vida', 'Adicional'];
    this._doughnutChartLabels2.forEach((ele, index) => {
      if (this.retirement.labels.indexOf(ele) > -1) {
        this._doughnutChartData2[index] = this.retirement.values[this.retirement.labels.indexOf(ele)];
      }
      else {
        this._doughnutChartData2[index] = 0;
      }
    });
    this._doughnutChartData2 = this._doughnutChartData2.map(element => {
      return Math.round(element);
    });
    this.doughnutChartData2 = this._doughnutChartData2;
  }

  change() {
    this.calculate();
    this.paint1();
    this.paint2();
    this.realTime.emit({ formValues: this.todo, values: { today: this.today, retirement: this.retirement } });
  }

  submit() {
    this.calculate();
    this.paint1();
    this.paint2();
    this.dataReturn.emit({ formValues: this.todo, values: { today: this.today, retirement: this.retirement } });
  }

  back(): void {
    this.formBack.emit();
  }

  deleteItem(index: number) {
    this.todo.splice(index, 1);
    this.change();
  }

  addItem() {
    this.todo.push({ label: 'Alimentación', type: 'Necesario', value: { today: 1000, retirement: 500 }, otherExpense: false })
    this.change();
  }


  importExpenses() {
    this.presentLoading();
    this.afAuth.authState.subscribe(user => {
      const uuid = user.uid
      this.afs.doc("Expenses/" + uuid).ref.get().then(doc => {
        if (doc.exists) {
          this.todo = [];
          const data = doc.data();
          const today = data.average as Array<any>;
          const retirement = data.retirement as Array<any>;
          today.forEach(element => {
            this.todo.push({
              label: element.label,
              type: element.type,
              value: {
                today: element.average,
                retirement: retirement[element.index].value
              },
              otherExpense: true
            });
          });
          this.change();
          this.presentToast("Gastos importados correctamente.");
        }
        else {
          this.presentToast("No se encontraron gastos.");
        }
        this.loading.dismiss();
      });
    });
  }

  presentLoading() {
    this.loading = this.loadingCtrl.create({});
    this.loading.present();
  }


  presentToast(message: string) {
    const toast = this.toastCtrl.create({
      message: message,
      duration: 4000
    });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/components/retirement-tools/retirement-calculator/gastos/gastos.ts